import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button, Spinner } from 'reactstrap';

export const AddTable = ({ isOpen, toggle, tableName, setTableName, tableDescription, setTableDescription, handleCreateTable, loading }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add New Table</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="tableName">Table Name</Label>
            <Input 
              type="text" 
              id="tableName" 
              value={tableName} 
              onChange={(e) => setTableName(e.target.value)} 
              disabled={loading}
            />
          </FormGroup>
          <FormGroup>
            <Label for="tableDescription">Table Description</Label>
            <Input 
              type="text" 
              id="tableDescription" 
              value={tableDescription} 
              onChange={(e) => setTableDescription(e.target.value)} 
              disabled={loading}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleCreateTable} disabled={loading}>
          {loading ? <><Spinner size="sm" /> Adding...</> : "Add"}
        </Button>{' '}
        <Button color="secondary" onClick={toggle} disabled={loading}>Cancel</Button>
      </ModalFooter> 
    </Modal>
  );
};
